import classNames from "classnames";

export function getClassNames(type: string, optionalClasses?: string): string {
	return classNames("fa", `fa-${type}`, optionalClasses);
}
